/**
 * This is a request processor file 
 * @description Request processors are functions that modify requests in some way. All request processor functions 
 * receive 'type', 'request', 'autoToken', 'token' and 'captchaAction' arguments and return the processed request.
 * @note Request processors can be chained so each subsequent processor will receive the request from the previous one.
 */

import {REQUEST_TYPE} from '../const';
import {addAuthTokenStandard, addAuthTokenJson, addAuthTokenToHeaders} from '../../auth/helper';
import {getStorageValue} from "../../storage";
import {access_token_storage_field_name, access_token_storage_type} from "../../../config";

/**
 * Add auth token to request
 * @note This is a request processor function.
 * 
 * @param {string} type - Internal request type (see imported REQUEST_TYPE const).
 * @param {string} url - Request's URL.
 * @param {string} api - Request's API (see 'io_base_urls' io config value for available APIs).
 * @param {string} endpoint - Request's API endpoint (see 'io_base_urls' io config value for available APIs).
 * @param {{method: string, headers: Headers, body: any}} request - Request object created by build request functions.
 * @param {boolean} autoToken - If true, auth token will be retrieved from storage.
 * @param {string} token - Custom auth token used only if 'autoToken' is false.
 * @param {string} captchaAction - Some captcha implementations can accept an actions name to differentiate between 
 * different captcha requests for analytic purposes. Use this argument to set the action name.
 * @return {Object} Processed request.
 */
const processRequest = (type, url, api, endpoint, request, autoToken, token, captchaAction) => {
	// Automatically get auth token from storage if specified
	if (autoToken) token = getStorageValue(access_token_storage_field_name, access_token_storage_type);
	
	if (token) {
		switch (type) {
			case REQUEST_TYPE.STANDARD:
				request.body = addAuthTokenStandard(token, request.headers, request.body);
				break;
			case REQUEST_TYPE.JSON:
				request.body = addAuthTokenJson(token, request.headers, request.body);
				break;
			default:
				addAuthTokenToHeaders(token, request.headers);
		}
	}
	
	return request;
};

export default processRequest;